import React from 'react';
import { motion } from 'framer-motion';
import { Check, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { OwnerButton } from '../OwnerShell';
import { StatusBadge } from '../../common/StatusBadge';
import { useOwnerService } from '../../../contexts/OwnerServiceContext';
import type { OwnerNav } from '../../../types/owner';
export function OwnerSubmitted({
  nav
}: {
  nav: OwnerNav;
}) {
  const navigate = useNavigate();
  const {
    applications
  } = useOwnerService();
  const app = applications.find(a => a.id === nav.focusAppId);
  return <div className="no-scrollbar flex h-full flex-col overflow-y-auto bg-white px-5 pb-6 pt-10 text-center" data-id="element-1984" data-mp="2codqgbnafbww">
      <motion.div initial={{
      scale: 0.6,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 18
    }} className="relative mx-auto" data-id="element-1985" data-mp="27p155vc2ecwf">
        <span className="absolute inset-0 -m-4 rounded-full bg-emerald-50" data-id="element-1986" data-mp="3j4y84ngqmxcn" />
        <span className="relative flex h-24 w-24 items-center justify-center rounded-full bg-bdgreen-600 text-white shadow-lg" data-id="element-1987" data-mp="3j72ah0yznoat">
          <Check className="h-14 w-14" strokeWidth={3} data-id="element-1988" data-mp="26nrzhza2blod" />
        </span>
      </motion.div>
      <h1 className="mt-8 font-heading text-2xl font-bold text-navy-900" data-id="element-1989" data-mp="2bnnrt19edoo3">আবেদন সফলভাবে জমা হয়েছে</h1>
      <p className="mt-1 text-sm text-slate-500" data-id="element-1990" data-mp="2gm8ud7c4gkfp">আবেদনের অবস্থা SMS ও নোটিফিকেশনের মাধ্যমে জানানো হবে।</p>

      <div className="mt-6 rounded-xl border border-border bg-slate-50 p-4 text-left" data-id="element-1991" data-mp="1iz8rlkuxdawt">
        <p className="text-[11px] text-slate-500" data-id="element-1992" data-mp="1nxk11uhb5jei">Application ID</p>
        <p className="font-mono text-lg font-bold tracking-wide text-navy-900" data-id="element-1993" data-mp="1ny3b6p0pv3hz">{app?.id ?? nav.focusAppId}</p>
        <div className="mt-3 grid grid-cols-2 gap-3 border-t border-slate-200 pt-3 text-[13px]" data-id="element-1994" data-mp="1sv3e4r29rq4v">
          <div data-id="element-1995" data-mp="1xppnypspdamu"><p className="text-[11px] text-slate-500" data-id="element-1996" data-mp="1xpg1hc6v9llw">গাড়ি</p><p className="font-semibold text-navy-900" data-id="element-1997" data-mp="1077m3znnamef">{app?.vehicleReg}</p></div>
          <div data-id="element-1998" data-mp="156sh5yzp2alv"><p className="text-[11px] text-slate-500" data-id="element-1999" data-mp="156k68cn4tfdb">জমার তারিখ</p><p className="font-semibold text-navy-900" data-id="element-2000" data-mp="15591a9hya1km">১৩/১০/২০২৬</p></div>
          <div className="col-span-2" data-id="element-2001" data-mp="x532jqmhqg7i"><p className="mb-1 text-[11px] text-slate-500" data-id="element-2002" data-mp="x4jmkfgei1w4">অবস্থা</p><StatusBadge tone="orange" data-id="element-2003" data-mp="t3zptczqp0ai">ডিএমপি যাচাই অপেক্ষমাণ</StatusBadge></div>
        </div>
      </div>

      <button onClick={() => navigate(`/admin/owner/applications/${app?.id ?? ''}`)} className="mt-3 flex items-center justify-center gap-1.5 rounded-lg border border-dashed border-navy-300 py-2 text-[11.5px] font-medium text-navy-700" data-id="element-2004" data-mp="16v4fpndb2e7n">
        <ExternalLink className="h-3.5 w-3.5" data-id="element-2005" data-mp="e9ld1u6rqn4a" />প্রোটোটাইপ: ওয়েব অ্যাডমিনে এই আবেদন দেখুন
      </button>

      <div className="mt-auto space-y-2.5 pt-6" data-id="element-2006" data-mp="a8jc98x7e307">
        <OwnerButton onClick={() => {
        nav.reset('tracking');
      }} data-id="element-2007" data-mp="o6zeamk4f5c0">আবেদনের অবস্থা দেখুন</OwnerButton>
        <OwnerButton variant="outline" onClick={() => nav.reset('home')} data-id="element-2008" data-mp="j5tkeleq5c0w">হোমে ফিরে যান</OwnerButton>
      </div>
    </div>;
}